import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { UpdaterService } from '@app/core/updater/updater.service';

export function provideUpdater(): EnvironmentProviders {
  return provideAppInitializer(() => {
    inject(UpdaterService);
  });
}
